import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisCollectionsRoute: InvariantJiraRoute = {
	name: 'polaris-collections',
	path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
	query: ['projects?', 'owners?'],
	exact: true,
};
